(function($) {

  $(document).ready(function() {

    $(function() {
      // Remove Search if user Resets Form or hits Escape!
      $('body, .dl-expandable-search[role="search"] button[type="reset"]').on('click keyup', function(event) {
        console.log(event.currentTarget);
        if (event.which == 27 && $('.dl-expandable-search[role="search"]').hasClass('active') ||
          $(event.currentTarget).attr('type') === 'reset') {
          closeSearch();
        }
      });

      function closeSearch() {
        var $form = $('.dl-expandable-search[role="search"].active');
        $form.find('input').val('');
        $form.removeClass('active');
        $form.addClass('inactive');
      }

      //Resize Window
      var $window = $(window);

      function checkWidth() {
        var windowsize = $window.width();
        if (windowsize > 767) {
          event.preventDefault();
          return false;
        }
      }

      // Show Search if form is not active // event.preventDefault() is important, this prevents the form from submitting
      $(document).on('click', '.dl-expandable-search[role="search"]:not(.active) button[type="submit"]', function(event) {
        //Prevent Default if > 767 window width
        checkWidth();

        // Bind event listener
        $(window).resize(checkWidth());
        var $form = $(this).closest('form'),
          $input = $form.find('input');
        $form.removeClass('inactive');
        $form.addClass('active');
        //$('#header-1').addClass('search-active');
        $input.focus();
      });

      //Close search when clicking outside search
      $('body').bind('click', function(e) {
        if ($(e.target).closest('.dl-expandable-search[role="search"]').length === 0) {
          closeSearch();
        }
      });


    });

  });

})(jQuery);
